import { useCallback, useRef } from "react";

export const useEditRefresher = (callback: () => Promise<void>) => {
  const ionRefresherRef = useRef<HTMLIonRefresherElement>(null);
  const refreshCallback = useCallback((event?: CustomEvent) => {
    // Ignorer l'événement passé par IonRefresher
    callback().then(() => {
      ionRefresherRef.current?.complete();
    }).catch(() => {
      ionRefresherRef.current?.complete();
    });
  }, [callback, ionRefresherRef]);

  return { ionRefresherRef, refreshCallback };
};
